/**
 * Dynamic Offers Collection Slider Statsig Tester
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ModelManager, getOrCreateStatsigManager, buildModelRequestPayload, Logger, syncDebugFlag, getStatsigClient, getSafeStorage, getCartItemsIdsString, getCartData } from './statsig-manager.js';
export function buildMinicartGatewayRequest(options) {
    var _a;
    const inputs = {
        cart: options.cart,
        prediction_timestamp: (_a = options.predictionTimestamp) !== null && _a !== void 0 ? _a : new Date().toISOString(),
        utms: arrayOrEmpty(options.utms),
        products: arrayOrEmpty(options.products),
        collections: arrayOrEmpty(options.collections),
    };
    if (options.customerId) {
        inputs.lookup_keys = {
            customer_features: options.customerId,
        };
    }
    const requestContext = {};
    if (options.stableId)
        requestContext.stable_id = options.stableId;
    if (options.allocatedExperiment)
        requestContext.allocated_experiment = options.allocatedExperiment;
    if (options.customerId)
        requestContext.customer_id = options.customerId;
    const request = {
        inputs,
    };
    if (Object.keys(requestContext).length > 0) {
        request.request_context = requestContext;
    }
    return request;
}
function arrayOrEmpty(value) {
    return Array.isArray(value) ? value : [];
}
function normalizeMinicartInferenceHubResponse(response) {
    if (!isRecord(response))
        return null;
    if (Array.isArray(response.outputs)) {
        return normalizeMinicartOutput(response.outputs[0]);
    }
    return normalizeMinicartOutput(response);
}
function buildMinicartGatewayEndpoint(modelName, gatewayBaseUrl) {
    return `${gatewayBaseUrl}/v1/models/${encodeURIComponent(modelName)}:predict`;
}
function postMinicartGatewayRequest(modelName, gatewayBaseUrl, gatewayApiKey, request, timeout) {
    return __awaiter(this, void 0, void 0, function* () {
        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), timeout);
        try {
            const response = yield fetch(buildMinicartGatewayEndpoint(modelName, gatewayBaseUrl), {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${gatewayApiKey}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(request),
                signal: controller.signal,
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        }
        finally {
            window.clearTimeout(timeoutId);
        }
    });
}
function normalizeMinicartOutput(output) {
    if (!isRecord(output))
        return null;
    const productHandles = stringArray(output.product_handles);
    const productHandlesFemale = stringArray(output.product_handles_female);
    const productHandlesMale = stringArray(output.product_handles_male);
    const normalized = {
        product_handles: productHandles,
    };
    if (typeof output.gender_collections === "boolean") {
        normalized.gender_collections = output.gender_collections;
    }
    if (productHandlesFemale.length > 0) {
        normalized.product_handles_female = productHandlesFemale;
    }
    if (productHandlesMale.length > 0) {
        normalized.product_handles_male = productHandlesMale;
    }
    if (typeof output.render === "boolean") {
        normalized.render = output.render;
    }
    if (typeof output.fallback_reason === "string") {
        normalized.fallback_reason = output.fallback_reason;
    }
    return normalized;
}
function stringArray(value) {
    return Array.isArray(value) ? value.filter((item) => typeof item === "string" && item.length > 0) : [];
}
function isRecord(value) {
    return typeof value === "object" && value !== null;
}
const MODEL_KEY = "statsig:test:dyo:collection-slider";
const EXPERIMENT = {
    title: "DyoCollection",
    name: "dyo-minicart-recommender",
    gate: "dyo-minicart-recommender",
    layer: "dyo-minicart-recommender",
};
const DEBUG = true; // Altere para false para desativar logs deste teste
if (!customElements.get("dyo-collection-slider"))
    customElements.define("dyo-collection-slider", class DynamicOffersCollection extends HTMLElement {
        constructor() {
            super();
            this.customerId = this.getAttribute("data-customer-id") || null;
            this.sliderId = this.getAttribute("data-slider-id") || null;
            const paramsURL = new URLSearchParams(window.location.search);
            const utmGender = paramsURL.get("utm_gender");
            const utmContent = paramsURL.get("utm_content");
            // Mesma lógica do multiple-collections: utm_gender tem prioridade, depois utm_content
            this.utmGender = utmGender || utmContent;
            Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] UTM resolvida no DYO: utm_gender='${utmGender}', utm_content='${utmContent}', utmMatch='${this.utmGender}'`);
            this.statsigGate = this.getAttribute("data-statsig-gate") || EXPERIMENT.gate;
            this.statsigLayer = this.getAttribute("data-statsig-layer") || EXPERIMENT.layer;
            this.statsigExperimentTitle = this.getAttribute("data-statsig-experiment-title") || EXPERIMENT.title;
            this.statsigExperimentName = this.getAttribute("data-statsig-experiment-name") || this.statsigExperimentName;
            this.MODEL_KEY = `${this.getAttribute("data-model-key")}` || MODEL_KEY;
            this.maxProducts = parseInt(this.getAttribute("data-max-products")) || 0;
            this.modelLink = null;
            this.modelName = null;
            this.servingMode = "pichi2";
            this.gatewayBaseUrl = this.getAttribute("data-gateway-base-url") || null;
            this.gatewayApiKey = null;
            this.usesFeatureView = false;
            this.useInsiderSmartRecommenderId = null;
            this.statsigStableId = null;
            this.allocatedExperiment = null;
            this.updateTimeout = 0;
            this.isGateEnabled = this.getAttribute("data-is-gate-enabled") === "true"; //TODO: pegar via parametro
            this.REQUEST_TIMEOUT_MS = 4500;
            this.modelManager = new ModelManager();
            this.objExperimentInfos = {
                stable_id: this.statsigStableId,
                gate: this.statsigGate,
                layer: this.statsigLayer,
                cart: "",
                customer_id: this.customerId,
                allocated_experiment: this.allocatedExperiment,
                category: "Statsig",
                component: `${this.statsigExperimentName}`,
            };
        }
        connectedCallback() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    this.objExperimentInfos.cart = (yield getCartItemsIdsString()) || "";
                    syncDebugFlag(this.statsigExperimentName, DEBUG);
                    this.statsigManager = yield getOrCreateStatsigManager();
                    yield this.runTest();
                }
                catch (error) {
                    this.logError(`[DEBUG][Statsig][${this.statsigExperimentName}] StatsigManager not ready`, false, error);
                }
            });
        }
        runTest() {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                try {
                    Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Iniciando execução do Dynamic Offers Collection`);
                    const stableContext = yield ((_a = getStatsigClient()) === null || _a === void 0 ? void 0 : _a.getAsyncContext());
                    this.objExperimentInfos.stable_id = stableContext === null || stableContext === void 0 ? void 0 : stableContext.stableID;
                    this.statsigStableId = stableContext === null || stableContext === void 0 ? void 0 : stableContext.stableID;
                    const gateOpen = yield this.statsigManager.checkGate((_b = this.statsigGate) !== null && _b !== void 0 ? _b : "");
                    const shouldPersist = gateOpen;
                    if (!shouldPersist) {
                        this.forceFallbackInSlider("closedGate");
                        Logger.warn(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Gate closed. Exiting without persisting.`, this.objExperimentInfos);
                        return;
                    }
                    // const triggers = ["stable_id"];
                    // const shouldSend = shouldSendPayload(triggers, MODEL_KEY, "every");
                    // if (!shouldSend) {
                    //   Logger.warn(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Not available to send payload. Aborting...`, triggers, this.objExperimentInfos);
                    //   return;
                    // }
                    const layer = yield this.statsigManager.getLayerParams((_c = this.statsigLayer) !== null && _c !== void 0 ? _c : "");
                    if (!layer) {
                        this.forceFallbackInSlider("layerNotFound");
                        Logger.warn(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Layer not found. Exiting.`, this.objExperimentInfos);
                        return;
                    }
                    this.servingMode = layer.get("servingMode") === "inference_hub" ? "inference_hub" : "pichi2";
                    this.gatewayBaseUrl = this.stringLayerParam(layer.get("gatewayBaseUrl")) || this.gatewayBaseUrl;
                    this.gatewayApiKey = this.stringLayerParam(layer.get("gatewayApiKey")) || this.stringLayerParam(layer.get("apiKey"));
                    this.modelLink = this.servingMode === "pichi2" ? this.stringLayerParam(layer.get("modelUrl")) : null;
                    this.modelName = this.stringLayerParam(layer.get("modelName"));
                    this.usesFeatureView = this.booleanLayerParam(layer.get("usesFeatureView"));
                    this.allocatedExperiment = (_d = layer.allocatedExperimentName) !== null && _d !== void 0 ? _d : this.allocatedExperiment;
                    this.objExperimentInfos.allocated_experiment = this.allocatedExperiment;
                    Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] layer`, {
                        servingMode: this.servingMode,
                        gatewayBaseUrl: this.gatewayBaseUrl,
                        modelName: this.modelName,
                        usesFeatureView: this.usesFeatureView,
                        hasGatewayApiKey: Boolean(this.gatewayApiKey),
                    });
                    let persistedModelData = this.loadModelFromStorage();
                    Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Dados do modelo persistidos anteriormente:`, persistedModelData);
                    if (!persistedModelData || (!this.isHoldoutModel() && !this.isUseInsiderSmartRecommender())) {
                        /**
                         * Quando o modelo for random ou v0 devemos buscar o modelo sempre, pois a resposta pode variar a cada requisição mesmo que já tenhamos algo persistido.
                         */
                        Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Buscando dados do modelo...`);
                        persistedModelData = yield this.fetchDOCollectionData();
                        Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Dados do modelo recebidos:`, persistedModelData);
                    }
                    if (!persistedModelData) {
                        this.forceFallbackInSlider("modelDataNull");
                        Logger.warn(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Modelo retornou null/undefined. Forçando fallback.`, this.objExperimentInfos);
                        return;
                    }
                    if ((this.isHoldoutModel() || this.isUseInsiderSmartRecommender())) {
                        /**
                         * Mesmo que a resposta do modelo sempre seja a mesma, é importante fazer essa requisição para popular informações ao modelo,
                         * aqui não usamos async pois não é necessário aguardar resposta.
                         */
                        this.fetchDOCollectionData();
                    }
                    Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Dados do modelo atualizado`, persistedModelData);
                    if (this.isUseInsiderSmartRecommender()) {
                        this.useInsiderSmartRecommenderId = (persistedModelData === null || persistedModelData === void 0 ? void 0 : persistedModelData.useinsider_smart_recommender_id) || null;
                    }
                    if ((!this.isHoldoutModel() && !this.isUseInsiderSmartRecommender())) {
                        const hasAnyHandles = (persistedModelData.product_handles && persistedModelData.product_handles.length > 0) ||
                            (persistedModelData.product_handles_female && persistedModelData.product_handles_female.length > 0) ||
                            (persistedModelData.product_handles_male && persistedModelData.product_handles_male.length > 0);
                        if (!hasAnyHandles) {
                            this.forceFallbackInSlider("emptyHandles");
                            Logger.warn(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Modelo sem product_handles. Forçando fallback.`, persistedModelData);
                            return;
                        }
                        Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Utilizando lista de produtos do modelo`, persistedModelData);
                        let formattedProductUrlsList;
                        const useHandle = (_f = (_e = persistedModelData.product_handles) === null || _e === void 0 ? void 0 : _e.map(product_url => ({ product_url: `https://insiderstore.com.br/products/${product_url}` }))) !== null && _f !== void 0 ? _f : [];
                        const useFemale = (_h = (_g = persistedModelData.product_handles_female) === null || _g === void 0 ? void 0 : _g.map(product_url => ({ product_url: `https://insiderstore.com.br/products/${product_url}` }))) !== null && _h !== void 0 ? _h : [];
                        const useMale = (_k = (_j = persistedModelData.product_handles_male) === null || _j === void 0 ? void 0 : _j.map(product_url => ({ product_url: `https://insiderstore.com.br/products/${product_url}` }))) !== null && _k !== void 0 ? _k : [];
                        formattedProductUrlsList = {
                            gender_collections: persistedModelData.gender_collections,
                            product_handles: useHandle,
                            product_handles_female: useFemale,
                            product_handles_male: useMale
                        };
                        // const formattedProductUrlsList: ProductsUrlList = persistedModelData.product_handles?.map(product_url => ({ product_url: `http://127.0.0.1:9292/products/${product_url}` })) ?? [];
                        Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] formattedProductUrlsList:`, formattedProductUrlsList);
                        this.persistListInSlider(formattedProductUrlsList, "model");
                        return;
                    }
                    if (this.isHoldoutModel()) {
                        if (this.dataset.statsigExperimentName == "dyo-homepage-collection-random-v0") {
                            this.forceFallbackInSlider("propositalFallback");
                        }
                        else {
                            this.hideSmartRecommenderSlider("holdout");
                        }
                        return;
                    }
                    ;
                    if (this.useInsiderSmartRecommenderId) {
                        const useInsiderData = yield this.fetchUseInsiderCollectionData(this.useInsiderSmartRecommenderId);
                        if (!useInsiderData) {
                            this.hideSmartRecommenderSlider("useInsiderNotFound");
                            Logger.warn(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] useInsiderData not found. Exiting.`, this.objExperimentInfos);
                            return;
                        }
                        const formattedProductUrlsList = {
                            product_handles: (_m = (_l = useInsiderData === null || useInsiderData === void 0 ? void 0 : useInsiderData.products) === null || _l === void 0 ? void 0 : _l.map(product => ({ product_url: product.url }))) !== null && _m !== void 0 ? _m : []
                        };
                        (_p = (_o = useInsiderData === null || useInsiderData === void 0 ? void 0 : useInsiderData.products) === null || _o === void 0 ? void 0 : _o.map(product => ({ product_url: product.url }))) !== null && _p !== void 0 ? _p : [];
                        this.persistListInSlider(formattedProductUrlsList, "useInsider");
                        return;
                    }
                    Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Nenhuma useInsiderSmartRecommenderId encontrada`);
                    Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] force fallback`);
                    // this.forceFallbackInSlider("propositalFallback");
                    this.hideSmartRecommenderSlider("propositalFallback");
                }
                catch (error) {
                    this.logError(`[DEBUG][Statsig][${this.statsigExperimentName}] Unexpected error in runTest()`, false, error);
                }
            });
        }
        loadModelFromStorage() {
            const storage = getSafeStorage();
            let parsed = null;
            try {
                const raw = storage.getItem(this.MODEL_KEY);
                parsed = raw ? JSON.parse(raw) : null;
            }
            catch (_a) {
                parsed = null;
            }
            if (!parsed || typeof parsed !== "object")
                return null;
            return parsed;
        }
        fetchUseInsiderCollectionData(campaignId) {
            return __awaiter(this, void 0, void 0, function* () {
                if (window && window.Insider) {
                    function waitForInsiderLoad() {
                        return __awaiter(this, void 0, void 0, function* () {
                            return new Promise((resolve, reject) => {
                                window.Insider.eventManager.once("ins-sr:only-api-campaign:load", (event, data) => {
                                    resolve({ event, data });
                                });
                            });
                        });
                    }
                    return yield waitForInsiderLoad().then(({ _, data }) => {
                        if (data && data.campaignId === Number(campaignId))
                            return data;
                        return null;
                    });
                }
            });
        }
        fetchDOCollectionData() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.servingMode === "inference_hub") {
                    return this.fetchInferenceHubCollectionData();
                }
                if (!this.modelLink) {
                    this.logError("[DEBUG][Statsig][DyoCollection] Missing PiChi2 modelUrl", false);
                    return null;
                }
                const includeFields = [
                    "customer_id",
                    "stable_id",
                    "allocated_experiment",
                    "cartItemsIds",
                    "cart",
                    "utms"
                ];
                const payload = yield buildModelRequestPayload({
                    customer_id: this.objExperimentInfos.customer_id,
                    stable_id: this.objExperimentInfos.stable_id,
                    allocated_experiment: this.objExperimentInfos.allocated_experiment,
                    cartItemsIds: this.objExperimentInfos.cart,
                }, includeFields);
                Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] payload:`, payload);
                try {
                    const data = yield this.modelManager.getModel(this.modelLink, payload, { timeout: this.REQUEST_TIMEOUT_MS }, this.MODEL_KEY, includeFields);
                    Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Dados do modelo recebidos:`, data);
                    return data;
                }
                catch (error) {
                    this.logError(`[DEBUG][Statsig][${this.statsigExperimentName}] Failed to fetch DOCollectionData via ModelManager`, false, error);
                    return null;
                }
            });
        }
        fetchInferenceHubCollectionData() {
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (!this.gatewayBaseUrl || !this.gatewayApiKey || !this.modelName) {
                    this.logError("[DEBUG][Statsig][DyoCollection] Missing gatewayBaseUrl, gatewayApiKey or modelName for Inference Hub mode", false);
                    return null;
                }
                const contextPayload = yield buildModelRequestPayload({
                    customer_id: (_a = this.customerId) !== null && _a !== void 0 ? _a : undefined,
                    stable_id: this.objExperimentInfos.stable_id,
                    allocated_experiment: this.objExperimentInfos.allocated_experiment,
                }, ["utms", "products", "collections"]);
                const request = buildMinicartGatewayRequest({
                    cart: yield getCartData(),
                    utms: contextPayload.utms,
                    products: contextPayload.products,
                    collections: contextPayload.collections,
                    customerId: this.customerId,
                    stableId: this.objExperimentInfos.stable_id,
                    allocatedExperiment: this.objExperimentInfos.allocated_experiment,
                });
                Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Inference Hub Gateway payload:`, request);
                try {
                    const response = yield postMinicartGatewayRequest(this.modelName, this.gatewayBaseUrl, this.gatewayApiKey, request, this.REQUEST_TIMEOUT_MS);
                    const normalized = normalizeMinicartInferenceHubResponse(response);
                    if (!normalized)
                        return null;
                    this.persistInferenceHubModel(request, normalized);
                    Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Inference Hub normalized data:`, normalized);
                    return normalized;
                }
                catch (error) {
                    this.logError(`[DEBUG][Statsig][${this.statsigExperimentName}] Failed to fetch Inference Hub data`, false, error);
                    return null;
                }
            });
        }
        persistInferenceHubModel(request, modelData) {
            if (!this.MODEL_KEY)
                return;
            const storage = getSafeStorage();
            const savedAt = Date.now();
            const requestPayload = {
                timestamp: new Date().toISOString(),
                gatewayEndpoint: this.modelName ? buildMinicartGatewayEndpoint(this.modelName, this.gatewayBaseUrl) : null,
                modelName: this.modelName,
                usesFeatureView: this.usesFeatureView,
                payload: request,
            };
            try {
                storage.setItem(`${this.MODEL_KEY}:request`, JSON.stringify(requestPayload));
                storage.setItem(this.MODEL_KEY, JSON.stringify(Object.assign(Object.assign({}, modelData), { gatewayEndpoint: requestPayload.gatewayEndpoint, modelName: this.modelName, savedAt })));
            }
            catch (error) {
                Logger.warn(`[Statsig][${this.statsigExperimentName}] Failed to persist Inference Hub response using modelKey: ${this.MODEL_KEY}`, error);
            }
        }
        isHoldoutModel() {
            return this.modelName === "holdout" || this.modelName === "dyo-minicart-recommender-holdout";
        }
        isUseInsiderSmartRecommender() {
            return this.modelName === "useinsider_smart_recommender";
        }
        stringLayerParam(value) {
            return typeof value === "string" && value.length > 0 ? value : null;
        }
        booleanLayerParam(value) {
            return value === true || value === "true";
        }
        persistListInSlider(productsList, origin) {
            const sliderElement = document.querySelector(`#${this.sliderId}`);
            if (sliderElement) {
                const timestamp = `dynamic:${origin}:${this.sliderId}-${new Date().toISOString()}`;
                Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Persist Product List: ${timestamp}`);
                sliderElement.dynamicData = productsList;
                sliderElement.dataset.timestamp = timestamp;
                // Decide se devemos aplicar a lógica de UTM nas tabs com base nos dados do modelo,
                // em vez de depender apenas da estrutura de DOM (mais performático).
                const hasGenderCollections = !!productsList.gender_collections ||
                    (productsList.product_handles_female && productsList.product_handles_female.length > 0) ||
                    (productsList.product_handles_male && productsList.product_handles_male.length > 0);
                if (this.utmGender && hasGenderCollections) {
                    Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] persistListInSlider: aplicando UTM nas tabs (hasGenderCollections=${hasGenderCollections}, utm='${this.utmGender}')`);
                    this.applyUtmGenderTabs();
                }
                else {
                    Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] persistListInSlider: não aplicando UTM nas tabs (hasGenderCollections=${hasGenderCollections}, utm='${this.utmGender}')`);
                }
                return;
            }
            this.logError(`[DEBUG][Statsig][${this.statsigExperimentName}] Slider not founded`, true);
        }
        applyUtmGenderTabs(attempt = 0) {
            if (!this.utmGender) {
                Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] applyUtmGenderTabs: sem utmGender, abortando.`);
                return;
            }
            const utmLower = this.utmGender.toLowerCase();
            // Root: usamos o próprio dyo-collection-slider e procuramos o dynamic-collection-slider dentro dele.
            const root = this.querySelector("dynamic-collection-slider") ||
                this.parentElement ||
                this;
            if (!root) {
                Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] applyUtmGenderTabs: root não encontrado.`);
                return;
            }
            const options = Array.from(root.querySelectorAll(".do-select_collection"));
            const collections = Array.from(root.querySelectorAll(".do-collection__item"));
            Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] applyUtmGenderTabs attempt=${attempt}, utm='${this.utmGender}', options=${options.length}, collections=${collections.length}`);
            // Se ainda não há opções/coleções renderizadas, tentamos novamente após um pequeno delay.
            if ((!options.length || !collections.length) && attempt < 10) {
                setTimeout(() => this.applyUtmGenderTabs(attempt + 1), 150);
                return;
            }
            if (!options.length || !collections.length) {
                Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] applyUtmGenderTabs: sem options/collections após retries, abortando.`);
                return;
            }
            // Mapeia a UTM para o índice da coleção.
            // Pela section, index 0 = Masculino, index 1 = Feminino.
            let targetIndex = null;
            if (utmLower.includes("fem")) {
                targetIndex = "collection-1";
            }
            else if (utmLower.includes("masc") || utmLower.includes("male")) {
                targetIndex = "collection-0";
            }
            Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] applyUtmGenderTabs: utmLower='${utmLower}', targetIndex='${targetIndex}'`);
            if (!targetIndex) {
                // Se não conseguimos mapear a UTM para uma coleção, mantemos o comportamento padrão.
                return;
            }
            let matchFound = false;
            options.forEach((option) => {
                option.classList.remove("active");
                if (option.dataset.index === targetIndex) {
                    option.classList.add("active");
                    matchFound = true;
                }
            });
            collections.forEach((collection) => {
                collection.classList.remove("active");
                if (collection.dataset.index === targetIndex) {
                    collection.classList.add("active");
                }
            });
            Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] applyUtmGenderTabs: matchFound=${matchFound}`);
            if (!matchFound) {
                const firstOption = options[0];
                const firstCollection = collections[0];
                if (firstOption)
                    firstOption.classList.add("active");
                if (firstCollection)
                    firstCollection.classList.add("active");
            }
        }
        hideSmartRecommenderSlider(origin) {
            Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] hideSmartRecommenderSlider`);
            const sliderElementWrapper = document.querySelector(`.products-recommended-dyo`);
            const sliderElement = document.querySelector(`#${this.sliderId}`);
            if (sliderElementWrapper) {
                sliderElementWrapper.style.display = "none";
                if (sliderElement) {
                    const timestamp = `dynamic:${origin}:${this.sliderId}-${new Date().toISOString()}`;
                    sliderElement.useDynamicRecommender = false;
                    sliderElement.status = "forceNoRender";
                    sliderElement.dataset.timestamp = timestamp;
                    sliderElement.dispatchEvent(new CustomEvent("dyo:dynamic-data", {
                        bubbles: true,
                        detail: {
                            origin,
                            timestamp,
                            status: sliderElement.status,
                        },
                    }));
                }
                return;
            }
        }
        forceFallbackInSlider(origin) {
            const sliderElement = document.querySelector(`#${this.sliderId}`);
            if (sliderElement) {
                const timestamp = `dynamic:${origin}:${this.sliderId}-${new Date().toISOString()}`;
                Logger.log(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] Forçando fallback no slider: ${timestamp}`);
                sliderElement.useDynamicRecommender = false;
                sliderElement.dynamicData = { product_handles: [] };
                sliderElement.status = "fallbackReady";
                sliderElement.dataset.timestamp = timestamp;
                sliderElement.dispatchEvent(new CustomEvent("dyo:dynamic-data", {
                    bubbles: true,
                    detail: {
                        origin,
                        timestamp,
                        status: sliderElement.status,
                    },
                }));
                return;
            }
            this.logError(`[DEBUG][Statsig][${this.statsigExperimentName}] Slider not founded`, true);
        }
        logError(message, showError = false, error) {
            Logger.error(this.statsigExperimentName, `[DEBUG][Statsig][${this.statsigExperimentName}] ${message}`, error);
        }
    });
